<mat-card class="slidecontent">
    <div class="headcontent">
        <div class="pophead">
            <h3>Apply Filters</h3>
            <button mat-icon-button (click)="Closefilter(false)">
                <mat-icon class="close">close</mat-icon>
            </button>
        </div>

    </div>
    <div class="dialog_content">
        <mat-form-field>
            <mat-label>Facility Name</mat-label>
            <input matInput placeholder="Enter Name">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Location</mat-label>
            <input matInput placeholder="Enter location">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Speciality</mat-label>
            <mat-select>
                <mat-option value="one">Cardiology</mat-option>
                <mat-option value="two">Heart Surgery</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Equipment</mat-label>
            <mat-select>
                <mat-option value="one">Transcathleter</mat-option>
                <mat-option value="two">Oxygen Pump</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Radius</mat-label>
            <input matInput placeholder="Enter radius">
        </mat-form-field>

    </div>


    <div class="actionBtn">
        <button mat-flat-button class="calltoaction" type="submit" color="basic" (click)="Closefilter(false)"> Close </button>
        <button mat-flat-button class="calltoaction" type="submit" color="primary">Apply</button>
    </div>
</mat-card>


<div class="overlay" (click)="Closefilter(false)"></div>